import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Update.module.sass";
import TextInput from "../../../../../../components/TextInput";
import { get_role_by_id, update_role_by_id } from "../../../../../../API/RBAC";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { message } from "antd";
import Card from "../../../../../../components/Card";
import { useNavigate, useParams } from "react-router";
import Panel from "../Panel";
import Icon from "../../../../../../components/Icon";
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
});
const UpdateRole = () => {
  const navigate = useNavigate();
  const { id } = useParams(); 
  const [initialValues, setInitialValues] = useState({ name: "" });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRoleDetails = async () => {
      try {
        if (id) {
          setIsLoading(true);
          const res = await get_role_by_id(id);
          if (res && res.data) {
            setInitialValues({ name: res.data.role });
          }
        }
      } catch (error) {
        console.error("Error fetching role details:", error);
        message.error("Failed to fetch role details");
        navigate("/settingsDashboard/accessControl/roles");
      } finally {
        setIsLoading(false);
      }
    };

    fetchRoleDetails();
  }, [id, navigate]);

  const handleUpdate = async (values, { setSubmitting }) => {
    try {
      if (!id) {
        message.error("Role ID is missing");
        return;
      }

      const formData = {
        role: values.name,
      };

      const res = await update_role_by_id(id, formData);

      if (res && res.status === 200) {
        message.success("Role updated successfully");
        navigate(`/settingsDashboard/accessControl/roles/${id}`);
      }
    } catch (error) {
      console.error("Error updating role:", error);
      if (error.response?.data?.errors) {
        message.error(Object.values(error.response.data.errors[0])[0]);
      } else {
        message.error("Failed to update role");
      }
    } finally {
      setSubmitting(false);
    }
  };
  if (isLoading) {
    return <div>Loading...</div>; 
  }
  return (

    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={handleUpdate}
    >
      {({ isSubmitting }) => (
        <Form>
          <Card
            className={cn(styles.card)}
            title="Update Role"
            classTitle="title-red"
            head={
              <div className={styles.flex_box}>
                <button
                  className={cn("button-stroke")}
                  onClick={() =>
                    navigate("/settingsDashboard/accessControl/roles")
                  }
                >
                  <Icon name="arrow-left" size="24" />
                  <span>Back</span>
                </button>
              </div>
            }
          >
            <div className={styles.description}>
              <Field name="name">
                {({ field, meta }) => (
                  <TextInput
                    {...field}
                    label="Role Name"
                    tooltip="Maximum 50 characters."
                    className={styles.field}
                    error={meta.touched && meta.error ? meta.error : ""}
                    required
                  />
                )}
              </Field>
            </div>
          </Card>
          <div className="fixed bottom-7 left-30 right-5">
            <Panel isSubmitting={isSubmitting} />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default UpdateRole;
